module.exports = "/_next/static/images/DeletionRequests@3x-73fa48ee3753b71a42d3eee84c56fc74.webp";